import { Alert } from 'react-bootstrap';
import usePlan from '../hooks/usePlan';

/**
 * A notice for a screen whose feature the organization's plan doesn't include. The records stay visible; what is
 * refused is creating or changing them. Renders nothing when the plan has the feature.
 */
function FeatureNotice({ feature, className = 'mt-3', children }) {
  const { has, label, upgradeHint, plan } = usePlan();
  if (has(feature)) return null;
  const hint = upgradeHint(feature);
  return (
    <Alert variant="warning" className={`py-2 small ${className}`}>
      <strong>{label(feature)}</strong> isn&apos;t part of your {plan?.name ? `${plan.name} ` : ''}plan
      {hint ? <> (it is included in {hint})</> : null}. {children || 'You can still see any records you already have, but you can’t create or change them.'} Ask your
      administrator to upgrade the plan.
    </Alert>
  );
}

export default FeatureNotice;
